import { MDBox } from "../MDBox";
import { MDTypography } from "../MDTypography";
import welcome_screen_image from "../../../../assets/externalApplicationImages/welcome_screen_image.png"
import { MDButton } from "../MDButton";

interface IWelcomeScreenApplication {
  setHandleProceed: (i: boolean) => void;
}

export const WelcomeScreenExternalApplication = (props: IWelcomeScreenApplication) => {
    return (
      <>
        <MDBox sx={{ backgroundColor: "#FFFFFF", padding: "20px", margin: "30px" }}>
          <MDBox>
            <MDTypography sx={{ fontSize: "33px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", color: "#000000" }}>
              BEE Service Application
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px", display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "15px", color: "#727272" }}>
              Dedicated software for the efficient management of B-BBEE Verifications and related services. It streamlines compliance and promotes transparency.
            </MDTypography>
            <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img
                className="service_application_welcome_image"
                src={welcome_screen_image}
                style={{
                  maxWidth: "180px",
                  marginRight: "15px",
                }}
                alt="Service Application Welcome Screen Image"
              />
            </MDBox>
            <MDTypography sx={{ fontSize: "15px", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "12px", color: "#727272" }}>
              Your hard work is safe with us. Our system automatically saves your content, ensuring peace of mind as you create.
            </MDTypography>
          </MDBox>
          <hr />
          <MDBox>
            <MDTypography sx={{ fontWeight: 'bold', color: "#000000", paddingBottom: "15px" }}>
              What you need to complete on this form:
            </MDTypography>
            <div style={{ display: 'flex', gap: '20px', paddingBottom: '20px' }}>
              <MDBox
                sx={{
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  width: '50%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#096E7E',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '7px',
                      fontSize: '14px',
                    }}
                  >
                    1
                  </div>
                  <div>
                    <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Company Details</MDTypography>
                  </div>
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                    Accurate business details, such as registration number, VAT number, and location, are essential for BEE compliance and verification.
                  </MDTypography>
                </div>
              </MDBox>
              <MDBox
                sx={{
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  width: '50%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#096E7E',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '7px',
                      fontSize: '14px',
                    }}
                  >
                    2
                  </div>
                  <div>
                    <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Contacts</MDTypography>
                  </div>
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                    Provide key personnel details for seamless communication between our agency and your organisation. Include names and contact information for those handling BEE compliance, engagement, and communication.
                  </MDTypography>
                </div>
              </MDBox>
            </div>
            <div style={{ display: 'flex', gap: '20px', paddingBottom: '20px' }}>
              <MDBox
                sx={{
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  width: '50%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#096E7E',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '7px',
                      fontSize: '14px',
                    }}
                  >
                    3
                  </div>
                  <div>
                    <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Referred By</MDTypography>
                  </div>
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                    Accurate business details, such as registration number, VAT number, and location, are essential for BEE compliance and verification.
                  </MDTypography>
                </div>
              </MDBox>
              <MDBox
                sx={{
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  width: '50%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#096E7E',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '7px',
                      fontSize: '14px',
                    }}
                  >
                    4
                  </div>
                  <div>
                    <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Service Required</MDTypography>
                  </div>
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                    Indicate the BEE service your business requires, such as BBBEE verification gap review, ownership review, opinion, joint venture, training, SED beneficiary certificate, ownership certificate, or the re-evaluation of element(s).
                  </MDTypography>
                </div>
              </MDBox>
            </div>
            <div style={{ display: 'flex', gap: '20px', paddingBottom: '20px' }}>
              <MDBox
                sx={{
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  width: '50%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#096E7E',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '7px',
                      fontSize: '14px',
                    }}
                  >
                    5
                  </div>
                  <div>
                    <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Financial Information</MDTypography>
                  </div>
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                    Provide key financial details like net profit after tax. This information is critical for evaluating the economic impact of BEE initiatives and to ensure that you are verified and/or providing with information relating to the correct scorecard type.
                  </MDTypography>
                </div>
              </MDBox>
              <MDBox
                sx={{
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  width: '50%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#096E7E',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '7px',
                      fontSize: '14px',
                    }}
                  >
                    6
                  </div>
                  <div>
                    <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>BEE Commissioner & Other</MDTypography>
                  </div>
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                    Disclose ongoing investigations involving your business or structure. This transparency is essential for compliance reporting.
                  </MDTypography>
                </div>
              </MDBox>
            </div>
          </MDBox >
          <MDBox sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <MDButton color="primary" variant="contained" onClick={() => props.setHandleProceed(false)}>
              GET STARTED
            </MDButton>
          </MDBox>
        </MDBox>
      </>
    );
  }